import { _Environment } from 'services/_infra/environment';
import closedLogo from '../components/Nav/assets/Sidebar_Logo_Closed.png';
import closedLogoDEV from '../components/Nav/assets/Sidebar_Logo_Closed_DEV.png';
import closedLogoSTAGING from '../components/Nav/assets/Sidebar_Logo_Closed_STAGING.png';
import logo from '../components/Nav/assets/Sidebar_Logo_Open.png';
import openLogoCOMALTX from '../components/Nav/assets/Sidebar_Logo_Open_ComalTX.png';
import logoDEV from '../components/Nav/assets/Sidebar_Logo_Open_DEV.png';
import openLogoHARRISONKY from '../components/Nav/assets/Sidebar_Logo_Open_HarrisonKY.png';
import openLogoPITTSBURGHPA from '../components/Nav/assets/Sidebar_Logo_Open_PittsburghPA.png';
import logoSTAGING from '../components/Nav/assets/Sidebar_Logo_Open_STAGING.png';

export const getLogo = (sidebarOpen) => {
  const environment = _Environment();

  if (sidebarOpen) {
    if (environment === 'PITTSBURGHPA') return openLogoPITTSBURGHPA;
    else if (environment === 'HARRISONKY') return openLogoHARRISONKY;
    else if (environment === 'COMALTX') return openLogoCOMALTX;
    else if (environment === 'DEV' || environment === 'DEVDEMO' || environment === 'LOCALHOST')
      return logoDEV;
    else if (environment === 'STAGING') return logoSTAGING;
    else return logo;
  }

  if (environment === 'STAGING') return closedLogoSTAGING;
  else if (environment === 'DEV' || environment === 'DEVDEMO' || environment === 'LOCALHOST')
    return closedLogoDEV;
  else return closedLogo;
};
